import {RootState} from "../../../store";

export const getShowNavbarBurger = (state: RootState) => state.navbarReducer.isShowNavbarBurger;
